<template>
<app-card>
    <h4>TẠO PHÒNG MỚI</h4>
    <p class="fs-14 grey--text">Tạo phòng mới xây</p>
    <v-btn v-if="role === 'admin'" @click="$refs.inputUpload.click()" color="green" dark>
        Nhập excel (admin)
    </v-btn>
    <input v-show="false" ref="inputUpload" type="file" @change="onFileSelected" >
    <v-form @submit.stop.prevent="createRoom">
        <v-container fluid>
            <v-layout row wrap>
                <v-flex xs12 md3>
                    <v-select
                        label="Tòa nhà"
                        :disabled="loading.submit"
                        v-model="form.building"
                        :items="list_building"
                        prepend-icon="domain"
                        required
                    ></v-select>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field
                        label="Số phòng"
                        :disabled="loading.submit"
                        v-model="form.room_id"
                        required
                        type="text"
                        prepend-icon="meeting_room"
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field
                        label="Giá Phòng"
                        :disabled="loading.submit"
                        v-model.number="form.room_price"
                        required
                        min="0"
                        type="number"
                        prepend-icon="attach_money"
                    >
                        <template slot="append">
                            VND
                        </template>
                    </v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field
                        label="Giá cọc"
                        :disabled="loading.submit"
                        v-model.number="form.deposit_price"
                        required
                        prepend-icon="attach_money"
                    >
                        <template slot="append">
                            VND
                        </template>
                    </v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field
                        label="Tiền máy lạnh"
                        :disabled="loading.submit"
                        v-model.number="form.air_conditioner_price"
                        prepend-icon="ac_unit"
                        required
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field
                        label="Tiền máy giặt"
                        :disabled="loading.submit"
                        v-model.number="form.washing_machine_price"
                        prepend-icon="local_laundry_service"
                        required
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field
                        label="Tiền rác"
                        :disabled="loading.submit"
                        v-model.number="form.trash_price"
                        prepend-icon="delete"
                        required
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field
                        label="Tiền Điện (vnd/kwh)"
                        :disabled="loading.submit"
                        v-model.number="form.electric_price"
                        prepend-icon="flash_on"
                        required
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field
                        label="Tiền nước (vnd/m3)"
                        :disabled="loading.submit"
                        v-model.number="form.water_price"
                        prepend-icon="opacity"
                        required
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field
                        label="Tiền xe máy"
                        :disabled="loading.submit"
                        v-model.number="form.motorbike_price"
                        prepend-icon="motorcycle"
                        required
                    ></v-text-field>
                </v-flex>
                <v-flex xs12 md3>
                    <v-text-field
                        label="Tiền xe đạp"
                        :disabled="loading.submit"
                        v-model.number="form.bike_price"
                        prepend-icon="motorcycle"
                        required
                    ></v-text-field>
                </v-flex>
            </v-layout>
        </v-container>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                :loading="loading.submit"
                :disabled="loading.submit"
                type="submit"
                color="primary"
            >
                Tạo Phòng
            </v-btn>
        </v-card-actions>
        <!-- <v-btn @click="clear" color="primary">{{$t("message.clear")}}</v-btn> -->
    </v-form>
</app-card>
</template>
<script>
import api from '../../api'
import XLSX from 'xlsx'
export default {
    name: 'TaoPhong',
    data(){
        return{
            form: {
                building: 'BN',
                room_id: '101BN',
                room_price: 2400000,
                deposit_price: 2400000,
                air_conditioner_price: 300000,
                washing_machine_price: 35000,
                trash_price: 50000,
                electric_price: 3000,
                water_price: 15000,
                motorbike_price: 100000,
                bike_price: 50000
            },
            list_building: [
                {text: 'Bảo Ngọc', value: 'BN'},
                {text: 'Gia Bảo', value: 'GB'},
                {text: 'Thanh Tâm', value: 'TT'},
                {text: 'Xuân Anh', value: 'XA'},
                {text: 'Mai Anh', value: 'MA'},
            ],
            loading: {
                submit: false
            },
            input_excel: null
        }
    },
    computed: {
        role(){
            return this.$store.state.auth.role
        }
    },
    methods: {
        createRoom: async function (){
            this.loading.submit = true
            let postData = Object.assign({}, this.form)
            let data = await api.createRoom(postData)
            if (data && data.status == 200){
                swal.fire('Thành Công', 'Đã tạo thành công phòng' + postData.room_id, 'success')
                this.$store.dispatch('getListRooms')
            } else {
                swal.fire('Lỗi', data.message, 'error')
            }
            this.loading.submit = false
        },
        onFileSelected: function (e){
            let files = e.target.files, f = files[0];
            let reader = new FileReader();
            let that = this
            reader.onload = function(e) {
                that.loader = true
                let data = new Uint8Array(e.target.result);
                let arr = new Array();
                for (let i = 0; i != data.length; ++i) arr[i] = String.fromCharCode(data[i]);
                let bstr = arr.join("");

                /* Call XLSX */
                let workbook = XLSX.read(bstr, {
                    type: "binary"
                });
                let first_sheet_name = workbook.SheetNames[0];
                let worksheet = workbook.Sheets[first_sheet_name];
                that.input_excel = XLSX.utils.sheet_to_json(worksheet, {
                    raw: true
                });
                that.creatRoomExcel()
            };
            reader.readAsArrayBuffer(f);
        },
        creatRoomExcel: async function (){
            this.loading.submit = true
            let promises = this.input_excel.filter(data => data.room_price).map( data => {
                let postData = Object.assign(data, {})
                postData.is_included_air_conditioner = !!postData.is_included_air_conditioner
                return api.createRoom(postData)
            })
            let data_array = await Promise.all(promises)
            let count_success = 0
            data_array.forEach(data => {
                if ( data.status === 200 ){
                    count_success++
                }
            });
            this.$store.dispatch('getListRooms')
            swal.fire('Thành công', `Tạo thành công: ${count_success} phòng`, 'success')
            this.loading.submit = false
        }
    }
}
</script>

